import { useQuery } from '@tanstack/react-query';
import { getAllTrades } from '../../api/api';
import { Loader2, ArrowRightLeft, User, Calendar, DollarSign } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const TradesTable = () => {
    const { t } = useLanguage();
    const { data: trades = [], isLoading } = useQuery({ queryKey: ['admin', 'trades'], queryFn: getAllTrades });

    if(isLoading) return (
        <div className="flex justify-center p-12">
            <Loader2 className="animate-spin w-8 h-8 text-primary" />
        </div>
    );
    
    return (
        <div className="overflow-x-auto bg-card rounded-xl border border-border shadow-sm">
            <table className="min-w-full divide-y divide-border">
                <thead className="bg-muted/50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-black uppercase tracking-widest text-muted-foreground">{t('tradeId')}</th>
                        <th className="px-6 py-3 text-left text-xs font-black uppercase tracking-widest text-muted-foreground">{t('initiator')}</th>
                        <th className="px-6 py-3 text-left text-xs font-black uppercase tracking-widest text-muted-foreground">{t('receiver')}</th>
                        <th className="px-6 py-3 text-left text-xs font-black uppercase tracking-widest text-muted-foreground">{t('status')}</th>
                        <th className="px-6 py-3 text-left text-xs font-black uppercase tracking-widest text-muted-foreground">{t('cashRequested')}</th>
                        <th className="px-6 py-3 text-left text-xs font-black uppercase tracking-widest text-muted-foreground">{t('updatedAt')}</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-border">
                    {trades.length === 0 ? (
                        <tr><td colSpan="6" className="px-6 py-12 text-center text-muted-foreground">{t('noOffersFound')}</td></tr>
                    ) : trades.map(trade => (
                        <tr key={trade._id} className="hover:bg-muted/30 transition-colors">
                            <td className="px-6 py-4 whitespace-nowrap text-[10px] font-mono text-muted-foreground">
                                {trade._id}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex flex-col">
                                    <span className="text-sm font-bold">{trade.initiator_email}</span>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex flex-col">
                                    <span className="text-sm font-bold">{trade.receiver_email}</span>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <span className={`px-2 py-1 rounded-full text-[10px] font-black uppercase tracking-tighter ${
                                    trade.status === 'accepted' ? 'bg-green-500/10 text-green-600' : 
                                    trade.status === 'rejected' ? 'bg-red-500/10 text-red-600' : 
                                    'bg-yellow-500/10 text-yellow-600'
                                }`}>
                                    {t(trade.status)}
                                </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-emerald-600">
                                {trade.cash_requested ? `$${trade.cash_requested.toLocaleString()}` : '-'}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-xs text-muted-foreground">
                                {new Date(trade.updatedAt).toLocaleDateString()}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default TradesTable;
